import { render } from "./UserReceivingInvoice.vue?vue&type=template&id=7d5eedeb"
import script from "./UserReceivingInvoice.vue?vue&type=script&lang=js"
export * from "./UserReceivingInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__